import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { db } from '../../firebase';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import EditableFeedback from './EditableFeedback';

const StudentDetails = () => {
  const { studentId, mockId = 'mock1' } = useParams();
  const navigate = useNavigate();

  const [student, setStudent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [writingScore, setWritingScore] = useState('');
  const [speakingScore, setSpeakingScore] = useState('');
  const [writing1Response, setWriting1Response] = useState('');
  const [writing2Response, setWriting2Response] = useState('');
  const [feedbackWriting1, setFeedbackWriting1] = useState('');
  const [feedbackWriting2, setFeedbackWriting2] = useState('');
  const [feedbackSpeaking, setFeedbackSpeaking] = useState('');
  const [scoresSubmitted, setScoresSubmitted] = useState(false);

  useEffect(() => {
    const fetchStudentDetails = async () => {
      try {
        const studentRef = doc(db, 'users', studentId);
        const studentSnap = await getDoc(studentRef);
        if (!studentSnap.exists()) {
          console.error('🚫 No such student!');
          setLoading(false);
          return;
        }
        setStudent(studentSnap.data());

        const writing1Ref = doc(db, 'users', studentId, 'mockAnswers', 'mock1_writing1');
        const writing2Ref = doc(db, 'users', studentId, 'mockAnswers', 'mock1_writing2');
        const [writing1Snap, writing2Snap] = await Promise.all([
          getDoc(writing1Ref),
          getDoc(writing2Ref),
        ]);
        
        if (writing1Snap.exists()) setWriting1Response(writing1Snap.data().essay);
        if (writing2Snap.exists()) setWriting2Response(writing2Snap.data().essay);
        
        const reviewRef = doc(db, 'users', studentId, 'mockAnswers', 'mock1_finalReview');
        const reviewSnap = await getDoc(reviewRef);
        if (reviewSnap.exists()) {
          const reviewData = reviewSnap.data();
          setWritingScore(reviewData.writingScore);
          setSpeakingScore(reviewData.speakingScore);
          setFeedbackWriting1(reviewData.feedbackWriting1 || '');
          setFeedbackWriting2(reviewData.feedbackWriting2 || '');
          setFeedbackSpeaking(reviewData.feedbackSpeaking || '');
          setScoresSubmitted(true);
        }
        
      } catch (error) {
        console.error('❌ Error fetching student details:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchStudentDetails();
  }, [studentId, mockId]);

  const handleSubmitMockScores = async () => {
    if (writingScore === '' || speakingScore === '') {
      alert('Please enter both scores.');
      return;
    }
    try {
      const reviewRef = doc(db, 'mockAnswers', `${studentId}_${mockId}_finalReview`);
      await setDoc(reviewRef, {
        writingScore: parseInt(writingScore),
        speakingScore: parseInt(speakingScore),
        feedbackWriting1,
        feedbackWriting2,
        feedbackSpeaking,
        submittedBy: 'teacher@email.com',
        submittedAt: new Date(),
      }, { merge: true });

      alert('✅ Scores and feedback submitted successfully!');
      setScoresSubmitted(true);
    } catch (err) {
      console.error('❌ Error saving scores:', err);
      alert('Failed to submit scores.');
    }
  };

  if (loading) return <div>Loading student details...</div>;
  if (!student) return <div>No student data found.</div>;

  return (
    <div style={styles.container}>
      <button style={styles.backButton} onClick={() => navigate('/teacher')}>
        ← Back to Dashboard
      </button>

      <h1>{student.name}'s Progress</h1>
      <p><strong>Email:</strong> {student.email || 'N/A'}</p>

      <h2>Mock Exam Review</h2>
      <div style={{ backgroundColor: '#fff3cd', padding: '15px', borderRadius: '8px', marginBottom: '20px' }}>
        <h3>Teacher Mock Scoring</h3>

        <p><strong>Writing Task 1:</strong></p>
        <div style={styles.responseBox}>{writing1Response || 'No submission.'}</div>
        <label>Feedback:</label>
        <EditableFeedback
          initialContent={feedbackWriting1}
          onSave={setFeedbackWriting1}
          disabled={scoresSubmitted}
        /><br /><br />

        <p><strong>Writing Task 2:</strong></p>
        <div style={styles.responseBox}>{writing2Response || 'No submission.'}</div>
        <label>Feedback:</label>
        <EditableFeedback
          initialContent={feedbackWriting2}
          onSave={setFeedbackWriting2}
          disabled={scoresSubmitted}
        /><br /><br />

        <label>Writing Score (0–30): </label>
        <input
          type="number"
          value={writingScore}
          onChange={(e) => setWritingScore(e.target.value)}
          disabled={scoresSubmitted}
        /><br /><br />

        <label>Speaking Score (0–30): </label>
        <input
          type="number"
          value={speakingScore}
          onChange={(e) => setSpeakingScore(e.target.value)}
          disabled={scoresSubmitted}
        /><br /><br />

        <label>Speaking Feedback:</label>
        <EditableFeedback
          initialContent={feedbackSpeaking}
          onSave={setFeedbackSpeaking}
          disabled={scoresSubmitted}
        /><br />

        <button
          onClick={handleSubmitMockScores}
          disabled={scoresSubmitted}
          style={{ marginTop: '10px', padding: '10px 20px', backgroundColor: '#28a745', color: 'white', border: 'none', borderRadius: '5px' }}
        >
          Submit Scores
        </button>
      </div>
    </div>
  );
};

export default StudentDetails;

const styles = {
  container: {
    padding: '20px',
    fontFamily: 'Arial, sans-serif'
  },
  backButton: {
    marginBottom: '20px',
    padding: '10px 20px',
    backgroundColor: '#ccc',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer'
  },
  responseBox: {
    whiteSpace: 'pre-wrap',
    padding: '10px',
    border: '1px solid #ccc',
    marginBottom: '10px',
    borderRadius: '5px',
    backgroundColor: '#f9f9f9'
  }
};
